import { useState } from 'react'

export const useFilters = () => {
  /** -------------------- Variables ----------------------- */
  const [geoMappingsFilter, setGeoMappingsFilter] = useState<string[]>([])
  const [selectedGeoMappings, setSelectedGeoMappings] = useState<string[]>([])
  const [productTreeFilter, setProductTreeFilter] = useState<string[]>([])
  const [selectedProductTree, setSelectedProductTree] = useState<string[]>([])
  const [pbmFilter, setPbmFilter] = useState<string[]>([])
  const [partnerIdFilter, setPartnerIdFilter] = useState<string[]>([])
  const [managerFilter, setManagerFilter] = useState<string[]>([])

  return {
    geoMappingsFilter,
    setGeoMappingsFilter,
    selectedGeoMappings,
    setSelectedGeoMappings,
    productTreeFilter,
    setProductTreeFilter,
    selectedProductTree,
    setSelectedProductTree,
    pbmFilter,
    setPbmFilter,
    partnerIdFilter,
    setPartnerIdFilter,
    managerFilter,
    setManagerFilter,
  }
}
